import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Box, CssBaseline } from '@mui/material';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Footer from './components/Footer';
import GlobalStyles from './styles/GlobalStyles';
import AppContent from './components/AppContent';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import InstallPWA from './components/common/InstallPWA';

const AppWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
}));

function App() {
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  return (
    <ErrorBoundary>
      <GoogleOAuthProvider clientId={googleClientId}>
        <LanguageProvider>
          <ThemeProvider>
            <CssBaseline />
            <Router>
              <AppWrapper>
                <GlobalStyles />
                <AppContent />
                <Footer />
                <InstallPWA />
              </AppWrapper>
            </Router>
          </ThemeProvider>
        </LanguageProvider>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  );
}

export default App;